import { render, staticRenderFns } from "./ListadoInscripcionProgramaUniversidad.vue?vue&type=template&id=29e2acdb"
import script from "./ListadoInscripcionProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoInscripcionProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoInscripcionProgramaUniversidad.vue?vue&type=style&index=0&id=29e2acdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports